import { render, staticRenderFns } from "./JumpTem.vue?vue&type=template&id=46037440&scoped=true"
import script from "./JumpTem.vue?vue&type=script&lang=js"
export * from "./JumpTem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46037440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46037440')) {
      api.createRecord('46037440', component.options)
    } else {
      api.reload('46037440', component.options)
    }
    module.hot.accept("./JumpTem.vue?vue&type=template&id=46037440&scoped=true", function () {
      api.rerender('46037440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/bannerTemplate/JumpTem.vue"
export default component.exports